import { useEffect, useState } from "react";
import { PendingGrantsClient } from "../../utilities/backend/client";
import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { ExportButton, StyledTableCell } from "../../styles/StyledComponents";

const PendingGrantsAdmin = () => {
  const pendingGrantsClient = new PendingGrantsClient();
  const [pendingGrants, setPendingGrants] = useState<any[]>();
  const [filterPendingGrants, seFilterPendingGrants] = useState<any[]>();
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("desc");
  const [sortField, setSortField] = useState<"firstName">("firstName");

  const [loading, setLoading] = useState<boolean>(true);
  const [isExporting, setIsExporting] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    pendingGrantsClient
      .pendingGrants_GetAll()
      .then(async (response) => {
        var data = JSON.parse(await response.data.text());
        setPendingGrants(data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (pendingGrants) {
      const sortedAccountHistories = [...pendingGrants].sort((a, b) => {
        if (sortField === "firstName") {
          const investmentNameA = a.investmentName ?? "";
          const investmentNameB = b.investmentName ?? "";

          const comparisonResult =
            investmentNameA.localeCompare(investmentNameB);
          return sortDirection === "asc" ? comparisonResult : -comparisonResult;
        }

        return 0;
      });

      seFilterPendingGrants(sortedAccountHistories);
    }
  }, [sortDirection, sortField, pendingGrants]);

  const handleExportAll = () => {
    setIsExporting(true);
    pendingGrantsClient
      .exportPendingGrants()
      .then(() => {
        console.log("Export successful");
      })
      .catch((error) => {
        console.error("Error exporting users", error);
      })
      .finally(() => {
        setIsExporting(false);
      });
  };

  const toggleSortDirection = (field: "firstName" | "firstName") => {
    setSortField((prevField) => {
      if (prevField === field) {
        setSortDirection((prevDirection) =>
          prevDirection === "asc" ? "desc" : "asc"
        );
      } else {
        setSortField(field);
        setSortDirection("asc");
      }
      return field;
    });
  };

  return (
    <>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            width: "100%",
            p: 2,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
            <ExportButton
              disabled={isExporting}
              variant="contained"
              color="primary"
              onClick={handleExportAll}
            >
              Export All
            </ExportButton>
          </Box>

          <TableContainer
            component={Paper}
            sx={{ width: "100%", overflowX: "auto" }}
          >
            <Table sx={{ minWidth: 650 }}>
              <TableHead>
                <TableRow>
                  <StyledTableCell>First name</StyledTableCell>
                  <StyledTableCell>Last name</StyledTableCell>
                  <StyledTableCell>Email</StyledTableCell>
                  <StyledTableCell>Amount</StyledTableCell>
                  <StyledTableCell>DAF provider</StyledTableCell>
                  <StyledTableCell>DAF name</StyledTableCell>
                  <StyledTableCell>Investment Name</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filterPendingGrants && filterPendingGrants.length > 0 ? (
                  filterPendingGrants.map((pendingGrant, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ maxWidth: "200px" }}>
                        {pendingGrant.userName}
                      </TableCell>
                      <TableCell sx={{ minWidth: "85px" }}>
                        {pendingGrant.lastName}
                      </TableCell>
                      <TableCell>{pendingGrant.email}</TableCell>
                      <TableCell>{pendingGrant.amount}</TableCell>
                      <TableCell>{pendingGrant.dafProvider}</TableCell>
                      <TableCell>{pendingGrant.dafName}</TableCell>
                      <TableCell>{pendingGrant.investmentName}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} sx={{ textAlign: "center" }}>
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </>
  );
};

export default PendingGrantsAdmin;
